import { render } from "./SideMenu.vue?vue&type=template&id=69d78a2a&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=69d78a2a&lang=scss&scoped=true"

import exportComponent from "E:\\Documents\\Development\\juwie-giveaway\\juwie-giveaway-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d78a2a"]])

export default __exports__